export const clientFieldsConfig = [
    {
        id: "lastName",
        label: "Client - Last Name",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "firstName",
        label: "Client - First Name",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "middleName",
        label: "Client - Middle Name",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "address",
        label: "Client - Address",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "city",
        label: "Client - City",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "state",
        label: "Client - State",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "zipCode",
        label: "Client - Zip Code",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "birthDate",
        label: "Client - Birth Date",
        type: "date",
        typeLabel: "Date",
        origin: "Client",
    },
    {
        id: "ssn",
        label: "Client - SSN",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "email",
        label: "Client - Email",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "homePhone",
        label: "Client - Home Phone",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "fullName",
        label: "Client - Full Name",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "fullAddress",
        label: "Client - Full Address",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "alienRegistrationNo",
        label: "Client - Alien Registration No.",
        type: "text",
        typeLabel: "Text",
        origin: "Client",
    },
    {
        id: "attorney.lastName",
        label: "Attorney - Last Name",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.firstName",
        label: "Attorney - First Name",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.middleName",
        label: "Attorney - Middle Name",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.address",
        label: "Attorney - Address",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.address2",
        label: "Attorney - Address 2",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.city",
        label: "Attorney - City",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.state",
        label: "Attorney - State",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.zipCode",
        label: "Attorney - Zip Code",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.fullAddress",
        label: "Attorney - Full Address",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.stateLicensed",
        label: "Attorney - State Licensed",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.licenseNumber",
        label: "Attorney - License Number",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.volagNumber",
        label: "Attorney - Volag Number",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.courtName",
        label: "Attorney - Court Name",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.email1",
        label: "Attorney - Email 1",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.email2",
        label: "Attorney - Email 2",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.phoneNumber",
        label: "Attorney - Phone Number",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "attorney.uscisAccount",
        label: "Attorney - USCIS Account",
        type: "text",
        typeLabel: "Text",
        origin: "Attorney",
    },
    {
        id: "docIssuer.name",
        label: "Doc Issuer - Name",
        type: "text",
        typeLabel: "Text",
        origin: "DocIssuer",
    },
    {
        id: "docIssuer.address",
        label: "Doc Issuer - Address",
        type: "text",
        typeLabel: "Text",
        origin: "DocIssuer",
    },
    {
        id: "docIssuer.email",
        label: "Doc Issuer - Email",
        type: "text",
        typeLabel: "Text",
        origin: "DocIssuer",
    },
    {
        id: "docIssuer.phoneNumber",
        label: "Doc Issuer - Phone Number",
        type: "text",
        typeLabel: "Text",
        origin: "DocIssuer",
    },
    {
        id: "docIssuer.fax",
        label: "Doc Issuer - Fax",
        type: "text",
        typeLabel: "Text",
        origin: "DocIssuer",
    },
    {
        id: "@today",
        label: "System - Today",
        type: "date",
        typeLabel: "Text - Date",
        origin: "System",
    },
    {
        id: "@true",
        label: "System - True",
        type: "checkbox",
        typeLabel: "Boolean - True",
        origin: "System",
    },
    {
        id: "#form.clone.field.value",
        label: "Form - Clone value from field >",
        description: "Copy the value of another field in this PDF",
        type: "text",
        typeLabel: "Text",
        origin: "Form",
    },
];

export const CLONE_FIELD_ID = "#form.clone.field.value";
export const CLONE_FIELD_PREFIX = "@formFieldValue.";

export const clientFieldOrigins = {
    Attorney: { label: "Attorney" },
    Client: { label: "Client" },
    DocIssuer: { label: "Doc Issuer" },
    Form: { label: "Form" },
    System: { label: "System" },
};

export const getOriginLabel = (origin) => clientFieldOrigins[origin]?.label || origin;

// "Client - First Name" -> "First Name"
export const getClientFieldShortLabel = (field) => field.label.replace(/^[^-]+ - /, "").replace(/\s*>$/, "");
